<template>
  <main id="subPage" class="admin">
    <!-- 카테고리 -->
    <section id="category">
      <h2>관리자 메뉴</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">관리자 메뉴</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="관리자 메뉴">관리자 메뉴</router-link></li>
            <li><router-link to="/usermanagement" title="시스템 관리">시스템 관리</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">회원관리</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="회원관리">회원관리</router-link></li>
            <li><router-link to="/discountvehicle" title="할인차량관리">할인차량관리</router-link></li>
            <li><router-link to="/periodparking" title="정기권 주차장관리">정기권 주차장관리</router-link></li>
            <li><router-link to="/noticemanagement" title="게시판관리">게시판관리</router-link></li>
            <li><router-link to="/popuplist" title="팝업/배너관리">팝업/배너관리</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">일반회원</p>
          <ul class="depth">
            <li><router-link to="/generalmembership" title="일반회원">일반회원</router-link></li>
            <li><router-link to="/businessmembership" title="사업자회원">사업자회원</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <h3 class="pageTitle">일반회원</h3>
        <article>
          <div class="searchArea">
            <div class="total">
              총<span>{{ memberCnt }}</span
              >건
            </div>
            <div class="searchBox">
              <div>
                <select id="" v-model="searchCondition" title="검색영역 선택">
                  <option value="1">아이디</option>
                  <option value="2">이름</option>
                  <option value="3">차량번호</option>
                </select>
                <input
                  type="text"
                  title="검색어 입력"
                  placeholder="검색어입력"
                  v-model="searchKeyword"
                  @keyup.enter="searchMember"/>
              </div>
              <button type="button" @click="searchMember" class="btn dkGray">검색</button>
            </div>
          </div>
          <div class="scroll-table">
            <i class="v-scroll"></i>
            <div class="table vertical-table">
              <table>
                <caption>
                  일반회원 테이블
                </caption>
                <colgroup>
                  <col style="width: 10%" />
                  <col style="width: auto" />
                  <col style="width: 20%" />
                  <col style="width: 20%" />
                  <col style="width: 20%" />
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">번호</th>
                    <th scope="col">아이디</th>
                    <th scope="col">이름</th>
                    <th scope="col">차량번호</th>
                    <th scope="col">가입일</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="nodate" v-if="nodata">
                    <td colspan="9">조회된 데이터가 없습니다.</td>
                  </tr>
                  <tr v-for="(item, index) in calData" :key="index" @click="view(item.empEsntlId)">
                    <td>{{ ( listData.length - index ) - ( (curPageNum-1) * dataPerPage ) }}</td>
                    <td>{{ item.empNo }}</td>
                    <td>{{ item.empNm }}</td>
                    <td>{{ item.empCarNo }}</td>
                    <td>{{ item.regDttm | ptDateFormat }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <v-pagination v-model="curPageNum" :length="numOfPages"></v-pagination>
        </article>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import moment from 'moment';

export default {
  data() {
    return {
      nodata: true,
      listData: [],
      memberCnt: 0,
      curPageNum: 1,
      dataPerPage: 10,
      searchCondition: 1,
      allChecked: false,
      checkedValues: [],
      searchKeyword: '',
    };
  },

  mounted() {
    this.searchMember();
  },

  methods: {
    checkboxCkc() {
      if (this.listData.length === this.checkedValues.length) {
        this.allChecked = true;
        return;
      }
      this.allChecked = false;
    },

    stopPropagation(e) {
      e.stopPropagation();
    },

    checkedAll() {
      if (!this.allChecked) {
        this.checkedValues = [];

        this.listData.forEach(element => {
          this.checkedValues.push(
            element.empEsntlId + ';' + element.empNo + ';' + element.empNm + ';' + element.regDttm,
          );
        });
      } else {
        this.checkedValues = [];
      }
    },

    existCheckBox() {
      if (this.checkedValues.length < 1) {
        alert('선택된 체크박스가 없습니다.');
        return false;
      } else {
        return true;
      }
    },

    timestamp: function (regDttm) {
      return moment(regDttm).format('YYYY-MM-DD');
    },

    async searchMember() {
      const res = await axios('get', '/api/member/list.json', {
        searchCondition: this.searchCondition,
        searchKeyword: this.searchCondition == 3 ? this.searchKeyword.replace(/\s/gi, '') : this.searchKeyword,
        empCd: 'USR',
      });
      const data = res.data.resultList;
      if (!data || data.length <= 0) {
        this.listData = [];
        this.nodata = true;
        return;
      }

      this.listData = data.filter(v => v.authorCode == 'ROLE_USER');
      this.nodata = false;
      this.memberCnt = this.listData.length;

      this.curPageNum = 1;
    },

    view(empNo) {
      this.$router.push({
        path: 'generalMembershipView',
        query: { id: empNo },
      });
    },
  },

  computed: {
    startOffset() {
      return (this.curPageNum - 1) * this.dataPerPage;
    },
    endOffset() {
      return this.startOffset + this.dataPerPage;
    },
    numOfPages() {
      return Math.ceil(this.listData.length / this.dataPerPage);
    },
    calData() {
      if (this.listData.length < 0) {
        return;
      }
      return this.listData.slice(this.startOffset, this.endOffset);
    },
  },
};
</script>
